import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { applicationReducer } from './store/reducers/applications.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ApplicationsEffects } from './applications.effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import {AdvertManifestModule} from '../../modules-ll/advert-manifest/advert-manifest.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        StoreModule.forFeature('applicationReducer', applicationReducer),
        EffectsModule.forFeature([ApplicationsEffects]),
    ],
    declarations: [],
    exports: []
})
export class ApplicationsModule { }
